import { useStaticQuery, graphql } from "gatsby";

export enum Trigger {
  MOUSEOUT = "mouseout",
  BUTTON = "button",
  LOCATION = "location",
  STATIC = "static",
}

export enum Scope {
  SESSION = "session",
  LIFE = "life",
}

export enum Device {
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export type Tab = {
  show: boolean;
  path: string;
};

export enum Type {
  CHECKBOX = "checkbox",
  INFORMATION = "information",
  STARS = "stars",
  RADIO = "radio",
  SELECT = "select",
  TEXT = "text",
}

export type Validation = {
  required?: string;
};

export type Field = {
  id?: string;
  label: string;
  name: string;
  type?: Type;
  options?: { label: string; value: string }[];
  validation?: Validation;
  dependency?: { name: string; value: string };
};

export type SurveyConfig = {
  group: string;
  type: string;
  name: string;
  version?: string;
  trigger: Trigger;
  fields: Field[];
  title?: string;
  footer?: string;
  priority?: number;
  path?: string;
  time?: number;
  device?: Device;
  scope?: Scope;
};

type SurveysConfig = {
  endpoint: string;
  identityPoolId: string;
  region: string;
  brand: string;
  surveys: SurveyConfig[];
  tab?: Tab;
  mlrVersion?: string;
};

export default function useConfiguration(): SurveysConfig {
  const { surveysConfig } = useStaticQuery<{ surveysConfig: SurveysConfig }>(
    graphql`
      query {
        surveysConfig {
          endpoint
          brand
          region
          identityPoolId
          mlrVersion
          surveys {
            group
            type
            name
            version
            trigger
            fields {
              label
              name
              type
              id
              options {
                label
                value
              }
              validation {
                required
              }
              dependency {
                name
                value
              }
            }
            title
            path
            priority
            time
            device
            scope
          }
          tab {
            show
            path
          }
        }
      }
    `
  );
  return surveysConfig;
}
